import { Link } from "@inertiajs/react";
import { Button } from "@/components/ui/button.tsx";
import { ArrowLeft } from "lucide-react";
import Form from "@/pages/communities/form.tsx";
import { CommunityType } from "@/pages/communities/types.ts";

interface EditProps {
    community: CommunityType
}

const Edit = ({ community }: EditProps) => {
    return (
        <div className="flex flex-col gap-6 p-8">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <Link href={`/communities/${community.id}`}>
                        <Button variant="outline" size="icon">
                            <ArrowLeft className="h-4 w-4" />
                        </Button>
                    </Link>
                    <div>
                        <h1 className="text-3xl font-bold text-foreground">Modifier la commune</h1>
                        <p className="text-sm text-muted-foreground">Mettre a jour les informations de la commune</p>
                    </div>
                </div>
            </div>

            <Form
                community={community}
                method="patch"
                action={`/communities/${community.id}`}
                submitText="Enregistrer les modifications"
            />
        </div>
    );
};

export default Edit;
